import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=1869d506&scoped=true"
import script from "./VerifyPhone.vue?vue&type=script&lang=js"
export * from "./VerifyPhone.vue?vue&type=script&lang=js"
import style0 from "./VerifyPhone.vue?vue&type=style&index=0&id=1869d506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1869d506",
  null
  
)

export default component.exports